











































































































































import {Component, Vue, Prop} from "vue-property-decorator";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {Paystub} from "@/dto/payroll/PayrollDTO";

export interface GenerateInvoiceForm {
	invoiceDate: string;
	selectedPayrollIds: number[];
}

export interface GenerateInvoiceModalProps {
	payrolls: Paystub[];
	onConfirm: (form: GenerateInvoiceForm) => void;
	onCancel: () => void;
}

@Component({
	components: {
		FontAwesomeIcon
	}
})
export default class GenerateInvoiceModal extends Vue {
	@Prop({required: true}) private payrolls!: Paystub[];
	@Prop({required: true}) private onConfirm!: (form: GenerateInvoiceForm) => void;
	@Prop({required: true}) private onCancel!: () => void;

	private form: GenerateInvoiceForm = {
		invoiceDate: '',
		selectedPayrollIds: []
	};

	public mounted(): void {
		// По умолчанию выбираем все payroll записи
		this.selectAllPayrolls();
	}

	private formatDate(date: Date | string): string {
		if (!date) return 'N/A';
		const dateObj = typeof date === 'string' ? new Date(date) : date;
		if (isNaN(dateObj.getTime())) return 'Invalid Date';
		return new Intl.DateTimeFormat('en-US', {
			year: 'numeric',
			month: '2-digit',
			day: '2-digit'
		}).format(dateObj);
	}

	private formatPayPeriod(start: string, end: string): string {
		if (!start || !end) return 'N/A';
		return `${start} - ${end}`;
	}

	private togglePayrollSelection(payrollId: number): void {
		const index = this.form.selectedPayrollIds.indexOf(payrollId);
		if (index > -1) {
			this.form.selectedPayrollIds.splice(index, 1);
		} else {
			this.form.selectedPayrollIds.push(payrollId);
		}
	}

	private selectAllPayrolls(): void {
		this.form.selectedPayrollIds = this.payrolls.map(p => p.payrollId);
	}

	private deselectAllPayrolls(): void {
		this.form.selectedPayrollIds = [];
	}

	private confirm(): void {
		if (this.form.selectedPayrollIds.length === 0) {
			alert('Please select at least one payroll record');
			return;
		}

		this.onConfirm(this.form);
	}

	private cancel(): void {
		this.onCancel();
	}
}
